import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faWindows } from '@fortawesome/free-brands-svg-icons'
import {
  faBell,
  faEyeSlash,
  faCalendar,
  faCalendarXmark
} from '@fortawesome/free-regular-svg-icons'
import {
  faCalendar as faCalendarSolid,
  faCircle,
  faCheck,
  faBox,
  faBoxOpen,
  faStar,
  faChevronRight,
  faChevronLeft,
  faDiagramProject,
  faBoxesStacked,
  faHandPeace
} from '@fortawesome/free-solid-svg-icons'

import {
  faBadge,
  faBadgeCheck,
  faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons'

// Register all the icons here
// See: https://github.com/FortAwesome/vue-fontawesome#usage
library.add(faWindows)

library.add(faCalendar)
library.add(faCalendarSolid)
library.add(faCalendarXmark)
library.add(faBell)
library.add(faEyeSlash)

library.add(faCircle)
library.add(faCheck)
library.add(faBox)
library.add(faBoxOpen)
library.add(faStar)
library.add(faChevronLeft)
library.add(faChevronRight)
library.add(faDiagramProject)
library.add(faBoxesStacked)
library.add(faHandPeace)

library.add(faBadge)
library.add(faBadgeCheck)
library.add(faTriangleExclamation)

Vue.component('font-awesome-icon', FontAwesomeIcon)
